module.exports = __webpack_public_path__ + "img/slide_05.c08f659e.png";